'use client';

import clsx from 'clsx';
import { PageSection, Reveal, RevealItem, SectionHeading } from '@/components/ui';
import { fadeUp } from '@/lib/motion';
import s from './IndustryChallenges.module.css';

function ChallengeCard({ index, title, desc }) {
  return (
    <>
      <span className={clsx(s.badge, 'serif-accent', 'italic')} aria-hidden="true">
        {String(index + 1).padStart(2, '0')}
      </span>
      <h3 className={s.cardTitle}>{title}</h3>
      <p className={s.cardDesc}>{desc}</p>
    </>
  );
}

/**
 * Industry daily challenges - full-width heading + card grid.
 */
export default function IndustryChallenges({
  id = 'challenges',
  bg = 'page',
  title,
  titleAccent,
  items,
  align = 'left',
  layout = 'default',
  hideHeader = false,
  compact = false,
}) {
  if (!items || items.length === 0) return null;

  const centered = align === 'center';

  return (
    <PageSection
      id={id}
      bg={bg}
      className={clsx(s.section, compact && s.compact)}
      tight={compact}
      aria-labelledby={hideHeader ? undefined : 'challenges-heading'}
    >
      {!hideHeader && (
        <Reveal variant={fadeUp} className={clsx(s.head, centered && s.headCenter)}>
          <SectionHeading
            title={title}
            titleAccent={titleAccent}
            accentBlock
            size="default"
            align={align}
            headingId="challenges-heading"
            className={s.headingWrap}
            titleClassName={s.heading}
          />
        </Reveal>
      )}

      <Reveal
        stagger={0.08}
        className={clsx(s.grid, layout === 'row5' && s.gridRow5)}
      >
        {items.map((c, i) => (
          <RevealItem key={i} as="article" className={s.card}>
            <ChallengeCard index={i} title={c.title} desc={c.desc} />
          </RevealItem>
        ))}
      </Reveal>
    </PageSection>
  );
}
